import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Frecuencia de asistencia — bar chart de % de miembros por hora del dia.
// Migra AttendanceFrecuencyChart.tsx (recharts BarChart).
export default class extends Controller {
  static values = {
    labels: Array,
    values: Array,
    label: String,
  }

  connect() {
    this.chart = new Chart(this.element.getContext("2d"), {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: this.labelValue,
            data: this.valuesValue,
            backgroundColor: "#2b7ff2",
            borderRadius: 2,
            barThickness: 10,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: "#7a7a7a", font: { size: 12 } },
            border: { display: false },
          },
          y: {
            beginAtZero: true,
            grid: { color: "#dfdfdf" },
            ticks: {
              color: "#7a7a7a",
              font: { size: 12 },
              callback: (value) => `${value}%`,
            },
            border: { display: false },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: { color: "#7a7a7a", font: { size: 13 }, boxWidth: 12 },
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y}%`,
            },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
